module.exports = __webpack_public_path__ + "img/absen.8568529c.png";